import { applyMiddleware, createStore as reduxCreateStore, type Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import { composeWithDevtools } from '../common/util/compose-with-devtools';

import rootEpic from './epics';
import rootReducer from './reducer';
import { type State } from './types';

export const createStore = (initialState: any = undefined, middlewares: any = []): Store<State> => {
	// @ts-ignore - Expected 4 type arguments, but got 1
	// This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
	const store = reduxCreateStore<State>(
		rootReducer,
		initialState,
		// @ts-ignore - Expected 1-2 arguments, but got 3
		// This was added when enrolling `@atlassiansox/project-pages` into JFE local consumption
		composeWithDevtools({ name: 'Project Pages' })(
			applyMiddleware(...middlewares, createEpicMiddleware(rootEpic)),
		),
	);

	return store;
};
